import { UnitSystem } from '~/_shared/types/googleMaps/googleMaps.types';
import {
  isGroupRadius, isRadiusProximity, type Proximity,
} from '~/_shared/types/proximity/proximity.types';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { convertDistanceToUnitSystem } from '~/_shared/utils/distance/distance.helpers';
import { getGroupRadiusProximityDetails } from '~/proximity/proximity.helpers';

export const AGS_REPORT_MAX_RADIUS_IN_MILES = 75;

export const isProximityValidForReportExport = (proximity: Proximity, spreadsheetRowId?: SpreadsheetRowId) => {
  if (isRadiusProximity(proximity) || isGroupRadius(proximity)) {
    let distance = proximity.data.radius;

    if (isGroupRadius(proximity)) {
      const groupRadiusProximityDetails = getGroupRadiusProximityDetails(proximity, spreadsheetRowId);
      distance = groupRadiusProximityDetails.radius;
    }

    const radius = convertDistanceToUnitSystem({
      distance,
      currentUnitSystem: proximity.data.unit,
      targetUnitSystem: UnitSystem.imperial,
    });

    return radius <= AGS_REPORT_MAX_RADIUS_IN_MILES;

  }

  return true;
};
